module.exports = __webpack_public_path__ + "static/media/web_mobile.36485fed.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/landing/web_mobile.png
// module id = 1255
// module chunks = 0